import React from 'react';

import styles from './skill.module.css';

import {
  VictoryChart,
  VictoryGroup,
  VictoryPolarAxis,
  VictoryLabel,
  VictoryArea,
  VictoryTheme
} from 'victory';

// const data = [[
//     {x: "Design", y: .5},
//     {x: "Process", y: .8},
//     {x: "Frontend", y: .9},
//     {x: "Backend", y: .8},
//     {x: "Solutions", y: .7}
//   ]
// ]
//
// const maxima = {
//   "Design": 10,
//   "Process": 10,
//   "Frontend": 10,
//   "Backend": 10,
//   "Solutions": 10
// };

const Quote = ({color, maxima, data}) => {
  return (
    <div className={styles.radarWrapper}>
      <VictoryChart polar
       theme={VictoryTheme.material}
       domain={{ y: [ 0, 1 ] }}
      >
       <VictoryGroup colorScale={["orange"]}
         style={{ data: { fillOpacity: 1, strokeWidth: 2 } }}
       >
         {data.map((data, i) => {
           return <VictoryArea key={i} data={data}/>;
         })}
       </VictoryGroup>
     {
       Object.keys(maxima).map((key, i) => {
         return (
           <VictoryPolarAxis key={i} dependentAxis
             style={{
               axisLabel: { padding: 10 },
               axis: { stroke: "none" },
               grid: { stroke: 'white', strokeWidth: 0.25, opacity: 0.8 }
             }}
             tickLabelComponent={
               <VictoryLabel labelPlacement="vertical"/>
             }
             labelPlacement="perpendicular"
             axisValue={i + 1}
             label={key}
             tickFormat={(t) => ''}
             tickValues={[1]}
           />
         );
       })
     }
       <VictoryPolarAxis
         labelPlacement="parallel"
         tickFormat={() => ""}
         style={{
           axis: { stroke: "none" },
           grid: { stroke: "white", opacity: 1 }
         }}
       />

     </VictoryChart>
    </div>
  )
}

export default Quote;